export default __webpack_public_path__ + "static/image2-c8d21bbd08afe775c530ec61acf00d10.gif";